import React from 'react';
import CanvasWrapper from './components/CanvasWrapper';
import EllipseCollection from './components/lines/EllipseCollection';

const SplineScene: React.FC = () => (
    <CanvasWrapper>
        <EllipseCollection count={5} />
    </CanvasWrapper>
);

export default SplineScene;